import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={25.988}
    height={22.871}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 24499 21560"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#000;stroke-width:271.489}.fil0{fill:#2b2a29}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="m748 2408 1618-13-1 7930-1614-2-3-7915zm2195-8c2084 32 7280 221 8988-205 1942-484 3907-2497 7189-887 1351 663 1631 1005 3483 1091 929 43 1137 270 1150 1203l-5 4632c1 632 196 1620-347 1947-334 200-2701 472-3688 951-1486 722-1140 1673-1140 3462 0 1542-6 3085 1 4627 4 827 144 1512-713 1629-411 56-1880 43-2325 11-914-66-891-502-886-1405 9-1595 103-5906-13-6948-339-3048-8875-2173-11704-2178l10-7930zM224 1925c-115 787-126 8289 16 8893 1646 451 9432-266 11621 287 852 215 2482 706 2231 1871-84 387-441 173-825 347-153 623-94 1346-60 1992l786 166c25 8 66 21 96 39 9 4598-580 5922 1916 5904 3573-24 3139 236 3139-4864 0-1136-104-2859 6-3925 98-958 1449-1322 2384-1528 1255-276 2422-7 2724-1204 151-598 52-3178 52-3982 0-997 243-2917-313-3598-582-713-2012-392-3145-791-989-348-1509-906-2725-1200-3081-746-4513 845-6294 1296-2196 556-10046-152-11609 297z"
        className="fill stroke1"
        style={{
          strokeWidth: 271.489,
        }}
      />
      <path
        d="M19941 7078c-925 4348-7607 3015-6646-1444 925-4286 7593-3001 6646 1444zm-4209-4574c-5152 1232-3315 8817 1723 7750 5167-1095 3389-8973-1723-7750z"
        className="fill stroke1"
        style={{
          strokeWidth: 271.489,
        }}
      />
      <path
        d="M17951 7998c483-36 458-46 475-561 12-363-13-795-14-1168-1-1566 209-1747-439-1740-256 476-208 3041-22 3469zM16433 7918c1 0-58 244 315 21 221-132 130-102 156-388l-1-2334c5-612 97-665-434-696-199 334-197 2433-131 3020l95 377zM14921 7933c703 193 463-832 462-1549-3-1546 204-1801-417-1875-251 405-151 1112-151 1644 0 967-74 1376 106 1780z"
        className="fill stroke1"
        style={{
          strokeWidth: 271.489,
        }}
      />
    </g>
  </svg>
);
export default SvgComponent;
